import { isNumberWithComma } from '../../../../../utils/function';
import { ValidationErrors } from './cascadeKrTypes';

const parseNum = (val: string | number | null | undefined): number | null => {
  if (typeof val === 'number') return val;
  if (!val) return null;
  if (!isNumberWithComma(val)) return null;
  return parseFloat(val);
};

/**
 * Validates all cascade KR form fields
 * @returns ValidationErrors object with any validation errors found
 */
export const validateCascadeKrForm = (
  metricName: string,
  initialData: string,
  target: string,
  stretch: string,
  lowerLimit: string,
  upperLimit: string,
  counting: number,
  isStretchEnabled: boolean,
  cascadeListLength: number,
  t: (key: string) => string,
): ValidationErrors => {
  const errors: ValidationErrors = {};

  const initialDataNum = parseNum(initialData);
  const targetNum = parseNum(target);
  const stretchNum = parseNum(stretch);
  const lowerLimitNum = parseNum(lowerLimit);
  const upperLimitNum = parseNum(upperLimit);
  const countingNum = parseNum(counting);

  // Metric name validation
  if (typeof metricName === 'undefined' || metricName === null || metricName === '') {
    errors.metricName = true;
  }

  // Initial data validation
  if (initialDataNum === null) {
    errors.initial_data = t('Enter value');
  }

  // Range validation (counting === 4)
  if (countingNum === 4) {
    if (lowerLimitNum === null) {
      errors.lower_limit = t('Enter value');
    }
    if (upperLimitNum === null) {
      errors.upper_limit = t('Enter value');
    }
    if (lowerLimitNum !== null && upperLimitNum !== null && upperLimitNum < lowerLimitNum) {
      errors.lower_limit = t('Lower limit value should be less than Upper limit value');
    }
  } else {
    // When stretch is enabled, at least one of committed or stretch is required.
    // Stretch-only is allowed (committed is not required).
    if (isStretchEnabled) {
      if (targetNum === null && stretchNum === null) {
        errors.target = t('Enter value');
        errors.stretch = t('Enter value');
      }
    } else if (targetNum === null) {
      errors.target = t('Enter value');
    }

    const isIncrease = countingNum === 1 || countingNum === 9;
    const isDecrease = countingNum === 2 || countingNum === 8;

    // Stretch vs target comparison validation
    if (targetNum !== null && isStretchEnabled && stretchNum !== null) {
      if (isIncrease && stretchNum < targetNum) {
        errors.stretch = t('Stretch target should be greater than committed');
      } else if (isDecrease && stretchNum > targetNum) {
        errors.stretch = t('Stretch target should be less than committed');
      }
    }

    const realTarget = isStretchEnabled && stretchNum !== null ? stretchNum : targetNum;
    // Initial data vs target comparison validation
    if (initialDataNum !== null && realTarget !== null) {
      if (isIncrease && initialDataNum > realTarget) {
        errors.initial_data = t('Starting value should be less than target');
      } else if (isDecrease && initialDataNum < realTarget) {
        errors.initial_data = t('Starting value should be greater than target');
      }
    }
  }

  // Cascade list validation
  if (cascadeListLength === 0) {
    errors.cascadeList = t('Please add at least one cascade KR');
  }

  return errors;
};
